import { getApiEnvironment } from './apiEnvironment'

const getSessionKey = (environment) => `adminSession:${environment}`

const parseSession = (session) => {
  try {
    return session ? JSON.parse(session) : null
  } catch {
    return null
  }
}

const getLegacySession = () => {
  const token = parseSession(sessionStorage.getItem('adminbear'))
  if (!token) return null

  return {
    token,
    user: parseSession(sessionStorage.getItem('user')),
  }
}

export const getAdminSession = (environment = getApiEnvironment()) => {
  const storedSession = parseSession(sessionStorage.getItem(getSessionKey(environment)))
  if (storedSession?.token) return storedSession

  const legacySession = getLegacySession()
  if (!legacySession) return null

  saveAdminSession(legacySession, environment)
  sessionStorage.removeItem('adminbear')
  sessionStorage.removeItem('user')
  return legacySession
}

export const saveAdminSession = (session, environment = getApiEnvironment()) => {
  sessionStorage.setItem(getSessionKey(environment), JSON.stringify(session))
}

export const clearAdminSession = (environment = getApiEnvironment()) => {
  sessionStorage.removeItem(getSessionKey(environment))
}
